import gql from 'graphql-tag';

export default gql`
  mutation feedbackProduct($input: FeedbackProductInput!) {
    feedbackProduct(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
